module.exports = __webpack_public_path__ + "static/media/3DPPA4.45e12493.jpg";